var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10.6673H9.33317M5.8665 14.6673H10.1332C11.2533 14.6673 11.8133 14.6673 12.2412 14.4493C12.6175 14.2576 12.9234 13.9516 13.1152 13.5753C13.3332 13.1475 13.3332 12.5874 13.3332 11.4673V4.53398C13.3332 3.41388 13.3332 2.85383 13.1152 2.426C12.9234 2.04968 12.6175 1.74372 12.2412 1.55197C11.8133 1.33398 11.2533 1.33398 10.1332 1.33398H5.8665C4.7464 1.33398 4.18635 1.33398 3.75852 1.55197C3.3822 1.74372 3.07624 2.04968 2.88449 2.426C2.6665 2.85383 2.6665 3.41388 2.6665 4.53398V11.4673C2.6665 12.5874 2.6665 13.1475 2.88449 13.5753C3.07624 13.9516 3.3822 14.2576 3.75852 14.4493C4.18635 14.6673 4.7464 14.6673 5.8665 14.6673ZM9.99984 6.00065C9.99984 7.10522 9.10441 8.00065 7.99984 8.00065C6.89527 8.00065 5.99984 7.10522 5.99984 6.00065C5.99984 4.89608 6.89527 4.00065 7.99984 4.00065C9.10441 4.00065 9.99984 4.89608 9.99984 6.00065Z",
    stroke: "#424242",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.6d82fee961e7440f9837acb876d5c555.svg";
export { ForwardRef as ReactComponent };